import React, { createContext, useContext, useState, useEffect } from 'react';
import { getCart } from '../services/cartService';
import { useAuth } from './AuthContext';

const CartContext = createContext();

export const useCart = () => {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error('useCart must be used within a CartProvider');
  }
  return context;
};

export const CartProvider = ({ children }) => {
  const [cartCount, setCartCount] = useState(0);
  const [cartItems, setCartItems] = useState([]);
  const { isAuthenticated } = useAuth();

  const updateCartCount = React.useCallback(async () => {
    try {
      const cartResponse = await getCart();
      if (cartResponse.success) {
        const items = cartResponse.data.items || [];
        const count = items.reduce((total, item) => total + (item.quantity || 0), 0);
        setCartCount(count);
        setCartItems(items);
      }
    } catch (error) {
      console.error('Error updating cart count:', error);
      setCartCount(0);
      setCartItems([]);
    }
  }, []);

  useEffect(() => {
    updateCartCount();
  }, [isAuthenticated, updateCartCount]);

  const refreshCart = React.useCallback(() => {
    updateCartCount();
  }, [updateCartCount]);

  return (
    <CartContext.Provider value={{
      cartCount,
      cartItems,
      refreshCart
    }}>
      {children}
    </CartContext.Provider>
  );
};